enum RoutesEnum {
  HOME = "/",
  DATABASES = "/db", // New route for databases
  SEARCH = "/search", // New route for the search page
  ABOUT = "/about", // New route for the about page
  DASHBOARD = "/dashboard",
  BIDS_CONVERTER = "/autobidsify",
}
export default RoutesEnum;
